import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthPage, Loader } from 'components';
import { redirectToBusinessDomain } from 'helpers';
import { useUser } from 'hooks';

import beachIllustration from 'assets/img/beach-illustration.jpeg';

const RedirectPage = () => {
  const { t } = useTranslation();
  const { currentUser } = useUser();

  // -----------------------------------------------------------------------------------------------------
  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  useEffect(() => {
    const businessName = currentUser?.businessName;

    if (businessName) {
      redirectToBusinessDomain(businessName);
    }
  }, [currentUser]);

  return (
    <>
      {currentUser && (
        <section className="auth-layout">
          <div className="image-container relative aspect-[3/2] lg:aspect-auto">
            <img
              className="image"
              src={beachIllustration}
              alt={t('auth:images.beachIllustrationAlt')}
              width="644"
              height="802"
            />
          </div>
          <div className="content-card flex items-center">
            <p className="text-xl font-bold">{t('redirect')} </p>
            <Loader loaderClass="w-8 h-8 mr-2" />
          </div>
        </section>
      )}
      {!currentUser && <AuthPage type="login" />}
    </>
  );
};

export default RedirectPage;
